<div *ngIf="showNewsTicker">
  <news-ticker [theme_id]="session?.user?.theme_id"></news-ticker>
</div>
<nav-header></nav-header>
<password-reset-banner></password-reset-banner>
<router-outlet></router-outlet>
<nav-footer></nav-footer>
